import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, IconButton, Grid } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(180deg, #0a0f1a 0%, #050810 100%)',
        borderTop: '1px solid rgba(148, 163, 184, 0.08)',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Logo and Tagline */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
              <Box
                component="img"
                src="/AIM_logo_transparent.png"
                alt="AIM Logo"
                sx={{
                  height: 80,
                  width: 'auto',
                  mb: 2,
                  opacity: 0.9,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: '#94a3b8',
                  textAlign: { xs: 'center', md: 'left' },
                  maxWidth: 280,
                }}
              >
                Always Inventing More – Building innovative digital solutions that make a difference.
              </Typography>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
              <Typography variant="h6" sx={{ color: '#f8fafc', mb: 1, fontSize: '1rem' }}>
                Quick Links
              </Typography>
              {['Home', 'About', 'Our Work', 'Contact'].map((item) => (
                <Link
                  key={item}
                  to={item === 'Home' ? '/' : item === 'Our Work' ? '/work' : `/${item.toLowerCase()}`}
                  style={{ textDecoration: 'none' }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#94a3b8',
                      transition: 'color 0.3s ease',
                      '&:hover': {
                        color: '#1f6fb2',
                      },
                    }}
                  >
                    {item}
                  </Typography>
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Social Links */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-end' } }}>
              <Typography variant="h6" sx={{ color: '#f8fafc', mb: 2, fontSize: '1rem' }}>
                Connect With Us
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton
                  href="mailto:info@alwaysinventingmore.com"
                  sx={{
                    color: '#94a3b8',
                    border: '1px solid rgba(148, 163, 184, 0.2)',
                    '&:hover': {
                      color: '#1f6fb2',
                      borderColor: '#1f6fb2',
                      backgroundColor: 'rgba(31, 111, 178, 0.1)',
                    },
                  }}
                >
                  <EmailIcon />
                </IconButton>
                <IconButton
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#94a3b8',
                    border: '1px solid rgba(148, 163, 184, 0.2)',
                    '&:hover': {
                      color: '#1f6fb2',
                      borderColor: '#1f6fb2',
                      backgroundColor: 'rgba(31, 111, 178, 0.1)',
                    },
                  }}
                >
                  <LinkedInIcon />
                </IconButton>
                <IconButton
                  href="https://github.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#94a3b8',
                    border: '1px solid rgba(148, 163, 184, 0.2)',
                    '&:hover': {
                      color: '#1f6fb2',
                      borderColor: '#1f6fb2',
                      backgroundColor: 'rgba(31, 111, 178, 0.1)',
                    },
                  }}
                >
                  <GitHubIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box
          sx={{
            mt: 6,
            pt: 3,
            borderTop: '1px solid rgba(148, 163, 184, 0.08)',
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: '#64748b' }}>
            © {currentYear} Always Inventing More LLC. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;

